import { createApp } from 'vue'
import Article from '@/components/help/Article.vue'
import { loadTranslations } from '@/js/global/vue-i18n'

const app = createApp(Article)

loadTranslations(app).then(() => {
    app.mount("#help-article-vue")
})